import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import "core-js/modules/es.array.map.js";
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import InlineList from 'components/InlineList';
import RadioButtonOption from 'components/RadioButtonOption';
import FormField from 'components/FormField';
import HintTooltip from 'components/HintTooltip';
import Button from 'components/Button';
import MarkAsDoneExplanationModal from 'components/MarkAsDoneExplanationModal';
import Flex from 'components/Flex';
import config from 'utils/config';
import { AUTOMATIC, MANUAL, MODES, getModeI18nLabel } from 'utils/asset/markAsDoneModes';
import Stack from 'components/Stack';
function ScormAutomaticMode() {
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var i18nLabel = getModeI18nLabel(AUTOMATIC);
  return /*#__PURE__*/React.createElement("span", null, t(i18nLabel), /*#__PURE__*/React.createElement(HintTooltip, {
    content: t('mark_as_done_automatic_scorm_description'),
    spacingLeft: "xxs"
  }));
}
export default function MarkAsDoneModeField(_ref) {
  var isScormCourse = _ref.isScormCourse,
    isMultiSelect = _ref.isMultiSelect,
    initialMode = _ref.initialMode,
    mode = _ref.mode,
    _onChange = _ref.onChange,
    resetMarkAsDoneMode = _ref.resetMarkAsDoneMode;
  var _useTranslation2 = useTranslation(),
    t = _useTranslation2.t;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isInfoModalOpen = _useState2[0],
    setIsInfoModalOpen = _useState2[1];
  var selectedMode = mode;
  if (!selectedMode) {
    selectedMode = config.manualMarkAsDone ? MANUAL : AUTOMATIC;
  }
  var MarkAsDoneRadioOptions = MODES.map(function (markAsDoneMode) {
    return /*#__PURE__*/React.createElement(RadioButtonOption, {
      key: "mark_as_done_".concat(markAsDoneMode.value),
      id: markAsDoneMode.value,
      label: t(markAsDoneMode.i18nTitleKey),
      checked: markAsDoneMode.value === selectedMode,
      value: markAsDoneMode.value,
      onChange: function onChange() {
        return _onChange(markAsDoneMode.value);
      }
    });
  });
  var MarkAsDoneRadioList = isMultiSelect ? /*#__PURE__*/React.createElement(Stack, {
    spacing: "xs"
  }, initialMode === 'mixed' && /*#__PURE__*/React.createElement(RadioButtonOption, {
    key: 'mark_as_done_mixed',
    id: "mark_as_done_mixed",
    label: t('state_mixed'),
    checked: selectedMode === 'mixed',
    value: "mixed",
    onChange: resetMarkAsDoneMode
  }), MarkAsDoneRadioOptions) : /*#__PURE__*/React.createElement(InlineList, {
    spacing: "m",
    as: "div",
    itemAs: "div"
  }, MarkAsDoneRadioOptions);
  return /*#__PURE__*/React.createElement(FormField, {
    as: "fieldset",
    label: t('form_mark_as_done_mode'),
    horizontal: true
  }, /*#__PURE__*/React.createElement(Flex, {
    justifyContent: "space-between"
  }, isScormCourse ? /*#__PURE__*/React.createElement(ScormAutomaticMode, null) : MarkAsDoneRadioList, /*#__PURE__*/React.createElement(Button, {
    icon: "info",
    size: "small",
    variant: "transparent",
    onClick: function onClick() {
      return setIsInfoModalOpen(true);
    }
  }, t('actions_info'))), isInfoModalOpen && /*#__PURE__*/React.createElement(MarkAsDoneExplanationModal, {
    onClose: function onClose() {
      return setIsInfoModalOpen(false);
    }
  }));
}